import authAxios from '@/axios/authAxios'
import aiAxios from '@/axios/aiAxios'

export function uploadFile() {}

export function getOSSToken() {
  return authAxios.post('/imageformat/getosstoken')
}

/**
 * 抠图
 * @param source oss地址
 * @returns {Promise<AxiosResponse<any>>}
 */
export function imgCut(source) {
  return aiAxios.post('/imageformat/cutout', {
    file_addr: source
  })
}
export function getTempOSSToken() {
  return axios.post('/api/getosstoken')
}
